import { buildHeaders } from "@bkry/bowline-utils";
import { ethers } from "ethers";
const { REACT_APP_GEN3RATOR_HOST } =
  typeof window !== "undefined" && window.env ? window.env : process.env;

export const prepareAttachChip = async ({
  generatorContractAddress,
  generatorTokenId,
  generatorContractName,
  generatorContractChainId,
  chipsContractAddress,
  chipTokenId,
  wallet,
  provider,
  connector,
  successCallbackFnc,
  errorCallbackFnc,
  transactionCallbackFnc,
}) => {
  try {
    const ethersProvider =
      provider ||
      (connector?.provider &&
        new ethers.providers.Web3Provider(connector?.provider, "any")) ||
      (window.ethereum &&
        new ethers.providers.Web3Provider(window.ethereum, "any"));

    const signer = ethersProvider.getSigner();

    const domain = {
      name: generatorContractName,
      version: "1",
      chainId: generatorContractChainId,
      verifyingContract: ethers.utils.getAddress(generatorContractAddress),
    };

    const types = {
      Gen3ratorAttach: [
        { name: "wallet", type: "address" },
        { name: "generatorTokenId", type: "uint256" },
        { name: "chipTokenId", type: "uint256" },
      ],
    };

    const message = {
      wallet: ethers.utils.getAddress(wallet),
      generatorTokenId,
      chipTokenId,
    };

    const signature = await signer._signTypedData(domain, types, message);

    return await attachChip({
      generatorContractAddress,
      generatorTokenId,
      generatorContractName,
      generatorContractChainId,
      wallet,
      chipsContractAddress,
      chipTokenId,
      signature,
      successCallbackFnc,
      errorCallbackFnc,
      transactionCallbackFnc,
    });
  } catch (e) {
    if (errorCallbackFnc) errorCallbackFnc(e);
    console.error(e);
  }
};

const attachChip = async ({
  generatorContractAddress,
  generatorTokenId,
  generatorContractName,
  generatorContractChainId,
  wallet,
  chipTokenId,
  signature,
  chipsContractAddress,
  successCallbackFnc,
  errorCallbackFnc,
  transactionCallbackFnc,
}) => {
  let headers = await buildHeaders();

  try {
    const ethersProvider = new ethers.providers.Web3Provider(
      window.ethereum,
      "any"
    );

    if (successCallbackFnc) successCallbackFnc();
    const response = await fetch(
      `${REACT_APP_GEN3RATOR_HOST}/token/${generatorContractAddress}/${generatorTokenId}/attach`,
      {
        headers,
        method: "POST",
        body: JSON.stringify({
          generatorContractName,
          generatorContractChainId,
          chipsContractAddress,
          chipTokenId,
          wallet,
          signature,
        }),
      }
    );

    const transaction = await response.json();

    if (transaction?.hash) {
      ethersProvider.once(transaction?.hash, () => {
        if (transactionCallbackFnc) transactionCallbackFnc();
      });
    }

    if (!response.ok) throw new Error(transaction.message);

    return transaction;
  } catch (e) {
    console.error(e);
    if (errorCallbackFnc) errorCallbackFnc(e);
  }
};
